import { getInitialDate } from "../../helpers/utils";
import {
  HIDE_PLAN_LIST_LOADER,
  SET_ERROR_PLAN_PROFILE,
  SET_PLAN_FILTER_DATA,
  SET_PLAN_LIST,
  SET_PLAN_PROFILE,
  SET_PLAN_USER_LIST,
  SHOW_PLAN_LIST_LOADER,
  SET_PLANS_PROFIT,
  PLANS_PROFIT_LOADER,
  SET_FILTERED_DATE,
  BULK_LOADER,
  SET_PLAN_GROUPS,
  GROUP_LOADER,
  SET_PAYOUT_CONDITIONS,
  PAYOUT_LOADER,
  SET_TOTAL_PROFIT_PLANS,
  SET_CUSTOM_PROFIT_BY_DAYS,
  LOADER_CUSTOM_PROFIT_BY_DAYS,
  SET_DATA_BY_DAYS,
  LOADER_DATA_BY_DAYS,
  SET_TOTAL_PLAN,
  SET_TOP_MANAGEMENT_REPORTS_FILTERS,
  SET_PROFIT_PLANS_WIDGET_LOADER,
  SET_PROFIT_PLANS_WIDGET,
  SET_PROFIT_PLAN_OFFERS,
  SET_PROFIT_PLAN_EXEC,
  SET_PROFIT_PLAN_MARGIN,
  SET_PROFIT_PLAN_CUSTOM_FILTER,
  LOAD_PROFIT_PLAN_CUSTOM_FILTER,
  SET_PROFIT_PLAN_MARGIN_FILTER,
  LOAD_PROFIT_PLAN_MARGIN_FILTER,
  LOADER_TOP_MANAGEMENT_REPORTS_FILTERS,
  SET_AGGREGATED_OFFER_PROFIT,
  SET_AGGREGATED_MANAGERS_PROFIT,
  LOADER_AGGREGATED_MANAGERS_PROFIT,
  LOADER_AGGREGATED_OFFER_PROFIT,
  GET_PLANS_PROFIT_STATUS,
  LOADER_PLANS_HR_OFFER_DETAILED,
  SET_PLANS_HR_OFFER_DETAILED
} from "./actionTypes";

const INIT_STATE = {
  data: {
    count: 0,
    next: null,
    previous: null,
    page: 1,
    sizePerPage: 10,
    results: [],
    offer_id: [],
    account_manager: [],
    // date_filters: {},
  },
  topReportsFilters: {
    offers: [],
    managers: [],
    buyers: [],
    platforms: [],
  },
  statusPlansProfit: null,
  aggregatedManagersData: {},
  loaderAggregatedManagers: false,
  aggregatedOfferData: {},
  loaderAggregatedOffer: false,
  topReportsLoader: false,
  topReportsWidgets: [
    {
      icon: "bx bx bx-table",
      title: "Plan",
      value: 0,
    },
    {
      icon: "bx bx bx-stats",
      title: "Profit",
      value: 0,
    },
    {
      icon: "bx bx-wallet-alt",
      title: "Rent profit",
      value: 0,
    },
    {
      icon: "mdi mdi-cash-plus",
      title: "Percent %",
      value: 0,
    },
    {
      icon: "bx bx-credit-card",
      title: "Debit",
      value: 0,
    },
    {
      icon: "bx bxs-credit-card",
      title: "Overdue debt",
      value: 0,
    },
    {
      icon: "bx bx-money",
      title: "Costs",
      value: 0,
    },
  ],
  profitPlanOffers: {},
  profitPlanExecution: [],
  profitPlanMargin: { options: {}, data: [] },
  topReportsLoading: false,
  dataByDays: [],
  loaderDataByDays: false,
  customProfitByDays: [],
  customProfitByDaysLoader: false,
  marginFilters: [],
  marginLoader: false,
  customFilters: {},
  customLoader: false,
  totalProfit: [],
  totalPlan: [],
  groups: {
    count: 0,
    next: null,
    previous: null,
    page: 1,
    sizePerPage: 10,
    results: [],
  },
  payoutData: {
    count: 0,
    next: null,
    previous: null,
    page: 1,
    sizePerPage: 10,
    results: [],
  },
  group_loader: false,
  // data: {
  //   date_from: "2022-06-01",
  //   date_to: "2022-06-01",
  //   results: [],
  // },
  filter_data: {
    offers: [],
    offers_with_id: [],
    account_managers: [],
  },
  profit_plans: {
    results: [],
  },
  profit_plans_loader: false,
  users_list: {},
  profileData: null,
  profitFilterData: {
    start_date: getInitialDate("start_date"),
    end_date: getInitialDate("end_date"),
  },
  hrOffersData: {},
  hrOffersDataLoader: false,
  isError: false,
  loading: false,
  bulk_loader: false,
  payout_loader: false,
  error: null,
};

const PlanList = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_PLAN_FILTER_DATA:
      return {
        ...state,
        filter_data: action.payload,
      };
    case SET_PLAN_LIST:
      return {
        ...state,
        data: action.payload,
      };
    case SHOW_PLAN_LIST_LOADER:
      return {
        ...state,
        loading: true,
      };
    case HIDE_PLAN_LIST_LOADER:
      return {
        ...state,
        loading: false,
      };
    case SET_PLAN_PROFILE:
      return {
        ...state,
        profileData: action.payload,
      };
    case SET_ERROR_PLAN_PROFILE:
      return {
        ...state,
        isError: action.payload,
      };
    case SET_PLAN_USER_LIST:
      return {
        ...state,
        users_list: action.payload,
      };
    case SET_PLANS_PROFIT:
      return {
        ...state,
        profit_plans: action.payload,
      };
    case PLANS_PROFIT_LOADER:
      return {
        ...state,
        profit_plans_loader: !state.profit_plans_loader,
      };
    case SET_FILTERED_DATE: {
      return {
        ...state,
        profitFilterData: action.payload,
      };
    }
    case BULK_LOADER: {
      return {
        ...state,
        bulk_loader: !state.bulk_loader,
      };
    }
    case SET_PLAN_GROUPS: {
      return {
        ...state,
        groups: action.payload,
      };
    }
    case SET_PAYOUT_CONDITIONS: {
      return {
        ...state,
        payoutData: action.payload,
      };
    }
    case PAYOUT_LOADER: {
      return {
        ...state,
        payout_loader: !state.payout_loader,
      };
    }
    case GROUP_LOADER: {
      return {
        ...state,
        group_loader: !state.group_loader,
      };
    }
    case SET_TOTAL_PROFIT_PLANS: {
      return {
        ...state,
        totalProfit: action.payload,
      };
    }
    case SET_CUSTOM_PROFIT_BY_DAYS: {
      return {
        ...state,
        customProfitByDays: action.payload,
      };
    }
    case SET_DATA_BY_DAYS: {
      return {
        ...state,
        dataByDays: action.payload,
      };
    }
    case LOADER_DATA_BY_DAYS: {
      return {
        ...state,
        loaderDataByDays: !state.loaderDataByDays,
      };
    }
    case SET_TOTAL_PLAN: {
      return {
        ...state,
        totalPlan: action.payload,
      };
    }
    case SET_TOP_MANAGEMENT_REPORTS_FILTERS: {
      return {
        ...state,
        topReportsFilters: action.payload,
      };
    }
    case LOADER_CUSTOM_PROFIT_BY_DAYS: {
      return {
        ...state,
        customProfitByDaysLoader: !state.customProfitByDaysLoader,
      };
    }
    case SET_PROFIT_PLANS_WIDGET: {
      return {
        ...state,
        topReportsWidgets: action.payload,
      };
    }
    case SET_PROFIT_PLANS_WIDGET_LOADER: {
      return {
        ...state,
        topReportsLoading: !state.topReportsLoading,
      };
    }
    case SET_PROFIT_PLAN_OFFERS: {
      return {
        ...state,
        profitPlanOffers: action.payload,
      };
    }
    case SET_PROFIT_PLAN_EXEC: {
      return {
        ...state,
        profitPlanExecution: action.payload,
      };
    }
    case SET_PROFIT_PLAN_MARGIN: {
      return {
        ...state,
        profitPlanMargin: action.payload,
      };
    }
    case SET_PROFIT_PLAN_CUSTOM_FILTER: {
      return {
        ...state,
        customFilters: action.payload,
      };
    }
    case LOAD_PROFIT_PLAN_CUSTOM_FILTER: {
      return {
        ...state,
        customLoader: !state.customLoader,
      };
    }
    case SET_PROFIT_PLAN_MARGIN_FILTER: {
      return {
        ...state,
        marginFilters: action.payload,
      };
    }
    case LOAD_PROFIT_PLAN_MARGIN_FILTER: {
      return {
        ...state,
        marginLoader: !state.marginLoader,
      };
    }
    case LOADER_TOP_MANAGEMENT_REPORTS_FILTERS: {
      return {
        ...state,
        topReportsLoader: !state.topReportsLoader,
      };
    }
    case SET_AGGREGATED_MANAGERS_PROFIT: {
      return {
        ...state,
        aggregatedManagersData: action.payload,
      };
    }
    case SET_AGGREGATED_OFFER_PROFIT: {
      return {
        ...state,
        aggregatedOfferData: action.payload,
      };
    }
    case LOADER_AGGREGATED_MANAGERS_PROFIT: {
      return {
        ...state,
        loaderAggregatedManagers: !state.loaderAggregatedManagers,
      };
    }
    case LOADER_AGGREGATED_OFFER_PROFIT: {
      return {
        ...state,
        loaderAggregatedOffer: !state.loaderAggregatedOffer,
      };
    }
    case GET_PLANS_PROFIT_STATUS:
      return {
        ...state,
        statusPlansProfit: action.payload,
      };
    case SET_PLANS_HR_OFFER_DETAILED: {
      return {
        ...state,
        hrOffersData: action.payload,
      };
    }
    case LOADER_PLANS_HR_OFFER_DETAILED: {
      return {
        ...state,
        hrOffersDataLoader: !state.hrOffersDataLoader,
      };
    }
    default:
      return state;
  }
};

export default PlanList;
